// Report-status contract fixture (US-882 · R-6) — registered through the
// US-883 fixtures mechanism (fixtures/apiFixtures.js).
//
// Mirrors GET /reports/<task_id>/status/ exactly as published by
// sdd/specs/US-891/contract.md §2: 200 with status "processing" |
// "ready" (+word_report_url) | "error" (+error) — never any other value.
// The trigger side (POST /country-data-range/ → 202 with task pointers) is
// already answered by fixtures/countryData.js (US-879).
//
// Each task transitions processing → ready after a fixed number of polls, so
// the UI exercises the real polling loop in fixtures mode. The DOCX URL is a
// placeholder — no real report is committed or served (AGENTS.md §6/§8);
// design.md §6 documents that the static demo's download link is inert.
import { registerFixture } from "./apiFixtures";

export const REPORT_FIXTURE = {
  // Polls before a task reports ready (1 = first poll "processing", 2nd "ready").
  pollsUntilReady: 2,
  // Task id that always reports a failed job — the contract's error case.
  errorTaskId: "00000000-0000-4000-8000-00000000dead",
  wordReportUrl: (taskId) =>
    `https://dochost.invalid/reports/${taskId}-summary-scorecard.docx`,
};

const pollCounts = new Map();

// Test hook: forget poll history so transitions replay deterministically.
export const resetReportFixture = () => pollCounts.clear();

registerFixture("reportStatus", (body, { path }) => {
  // Path shape from the catalog template: /reports/{task_id}/status/
  const taskId = path.split("/")[2] || "unknown";

  if (taskId === REPORT_FIXTURE.errorTaskId) {
    return {
      task_id: taskId,
      status: "error",
      error: "Report generation failed (fixture)",
    };
  }

  const polls = (pollCounts.get(taskId) || 0) + 1;
  pollCounts.set(taskId, polls);

  if (polls < REPORT_FIXTURE.pollsUntilReady) {
    return { task_id: taskId, status: "processing" };
  }
  return {
    task_id: taskId,
    status: "ready",
    word_report_url: REPORT_FIXTURE.wordReportUrl(taskId),
  };
});
